import { render, staticRenderFns } from "./VersionTabs.vue?vue&type=template&id=5663553f&"
import script from "./VersionTabs.vue?vue&type=script&lang=js&"
export * from "./VersionTabs.vue?vue&type=script&lang=js&"
import style0 from "./VersionTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports